module.exports = new __parcel__URL__("github-invertocat-logomark-darkmode.6cea6e35.svg").toString();